import { FunctionComponent } from 'react';
import styles from './CrystallineRift.module.css';
import ParallaxHero from './ParallaxHero';
import SocialBar from './SocialBar';
import SubscribeComponent from './SubscribeComponent';

const CrystallineRift: FunctionComponent = () => (
  <ParallaxHero>
    <p className={styles.studio}>
      Counterspell&nbsp;Games <span className={styles.sep}>presents</span>
    </p>

    <h1 className={styles.title}>
      <span className={styles.crystalline}>Crystalline</span>
      <span className={styles.rift}>Rift</span>
    </h1>

    <p className={styles.tagline}>Coming to Kickstarter in 2026</p>

    <div className={styles.spacer} />

    <SubscribeComponent />
    <SocialBar />
  </ParallaxHero>
);

export default CrystallineRift;
